export default __webpack_public_path__ + "static/media/hotline.fe696627.svg";